export default {
  label: {
    no: 'Mã giao dịch',
    systemOrderNo: 'số hệ thống',
    balance: 'số tiền',
    amount: 'số tiền chuyển',
    confirmTime: 'thời gian xác nhận',
    createTime: 'thời gian tạo',
    from: 'chuyển vào',
    id: 'mã chính ID',
    message: 'Trạng thái chuyển',
    status: 'trạng thái',
    to: 'chuyển ra',
    type: 'loại'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/userTransaction.js